import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from './types';

export const WalletOutlinedIcon: FC<IconProps> = ({ className, width = 24, height = 24 }) => {
  return (
    <SvgIcon
      className={className}
      viewBox={[0, 0, width, height].join(' ')}
      width={width}
      height={height}
      strokeWidth={0}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.8566 0.289062H1.1423C0.668192 0.289062 0.285156 0.672098 0.285156 1.14621V20.8605C0.285156 21.3346 0.668192 21.7176 1.1423 21.7176H20.8566C21.3307 21.7176 21.7137 21.3346 21.7137 20.8605V1.14621C21.7137 0.672098 21.3307 0.289062 20.8566 0.289062ZM19.7852 12.7176H11.428V9.28906H19.7852V12.7176ZM19.7852 19.7891H2.21373V2.21763H19.7852V7.57478H10.5709C10.0968 7.57478 9.71373 7.95781 9.71373 8.43192V13.5748C9.71373 14.0489 10.0968 14.4319 10.5709 14.4319H19.7852V19.7891ZM12.8209 11.0033C12.8209 11.2875 12.9338 11.56 13.1347 11.761C13.3356 11.9619 13.6081 12.0748 13.8923 12.0748C14.1765 12.0748 14.449 11.9619 14.6499 11.761C14.8508 11.56 14.9637 11.2875 14.9637 11.0033C14.9637 10.7192 14.8508 10.4467 14.6499 10.2457C14.449 10.0448 14.1765 9.93192 13.8923 9.93192C13.6081 9.93192 13.3356 10.0448 13.1347 10.2457C12.9338 10.4467 12.8209 10.7192 12.8209 11.0033Z" />
    </SvgIcon>
  );
};
